import { Directive, Input, Output, EventEmitter } from '@angular/core';
import { HostListener, HostBinding, ElementRef, Renderer2 } from '@angular/core';
export class TdFileDropDirective {
private _multiple: boolean = false;
private _disabled: boolean = false;
/**
 * multiple?: boolean
 * Sets whether multiple files can be dropped at once in host element, or just a single file.
 * Can also be 'multiple' native attribute.
 * @param {?} multiple
 * @return {?}
 */
set multiple(multiple: string | boolean) {
    this._multiple = multiple !== '' ? (multiple === 'true' || multiple === true) : true;
  }
/**
 * disabled?: boolean
 * Disabled drop events for host element.
 * @param {?} disabled
 * @return {?}
 */
set disabled(disabled: boolean) {
    this._disabled = disabled;
  }
/**
 * fileDrop?: function
 * Event emitted when a file or files are dropped in host element after being validated.
 * Emits a [FileList | File] object.
 */
onFileDrop: EventEmitter<FileList | File> = new EventEmitter<FileList | File>();
/**
 * Binds native 'multiple' attribute if [multiple] property is 'true'.
 * @return {?}
 */
get multipleBinding(): string {
    return this._multiple ? '' : undefined;
  }
/**
 * Binds native 'disabled' attribute if [disabled] property is 'true'.
 * @return {?}
 */
get disabledBinding(): string {
    return this._disabled ? '' : undefined;
  }
/**
 * @param {?} _renderer
 * @param {?} _element
 */
constructor(private _renderer: Renderer2,
private _element: ElementRef) {
  }
/**
 * Listens to 'drop' host event to get validated transfer items.
 * Emits the 'onFileDrop' event with a [FileList] or [File] depending if 'multiple' attr exists in host.
 * Stops event propagation and default action from browser for 'drop' event.
 * @param {?} event
 * @return {?}
 */
onDrop(event: Event): void {
    if (!this._disabled) {
      let /** @type {?} */ transfer: DataTransfer = ( /** @type {?} */((<DragEvent>event))).dataTransfer;
      let /** @type {?} */ files: FileList = transfer.files;
      if (files.length) {
        let /** @type {?} */ value: FileList | File = this._multiple ? (files.length > 1 ? files : files[0]) : files[0];
        this.onFileDrop.emit(value);
      }
    }
    this._renderer.removeClass(this._element.nativeElement, 'drop-zone');
    this._stopEvent(event);
  }
/**
 * Listens to 'dragover' host event to validate transfer items.
 * Checks if 'multiple' attr exists in host to allow multiple file drops.
 * Stops event propagation and default action from browser for 'dragover' event.
 * @param {?} event
 * @return {?}
 */
onDragOver(event: Event): void {
    let /** @type {?} */ transfer: DataTransfer = ( /** @type {?} */((<DragEvent>event))).dataTransfer;
    transfer.dropEffect = this._typeCheck(transfer.types);
    if (this._disabled || (!this._multiple &&
      ((transfer.items && transfer.items.length > 1) || ( /** @type {?} */((<any>transfer))).mozItemCount > 1))) {
      transfer.dropEffect = 'none';
    } else {
      transfer.dropEffect = 'copy';
    }
    this._stopEvent(event);
  }
/**
 * Listens to 'dragenter' host event to add animation class 'drop-zone' which can be overriden in host.
 * Stops event propagation and default action from browser for 'dragenter' event.
 * @param {?} event
 * @return {?}
 */
onDragEnter(event: Event): void {
    if (!this._disabled) {
      this._renderer.addClass(this._element.nativeElement, 'drop-zone');
    }
    this._stopEvent(event);
  }
/**
 * Listens to 'dragleave' host event to remove animation class 'drop-zone'.
 * Stops event propagation and default action from browser for 'dragleave' event.
 * @param {?} event
 * @return {?}
 */
onDragLeave(event: Event): void {
    this._renderer.removeClass(this._element.nativeElement, 'drop-zone');
    this._stopEvent(event);
  }
/**
 * Validates if the transfer item types are 'Files'.
 * @param {?} types
 * @return {?}
 */
private _typeCheck(types: string[] | DOMStringList): string {
    let /** @type {?} */ dropEffect: string = 'none';
    if (types) {
      if ((( /** @type {?} */((<any>types))).contains && ( /** @type {?} */((<any>types))).contains('Files'))
      || (( /** @type {?} */((<any>types))).indexOf && ( /** @type {?} */((<any>types))).indexOf('Files') !== -1)) {
        dropEffect = 'copy';
      }
    }
    return dropEffect;
  }
/**
 * @param {?} event
 * @return {?}
 */
private _stopEvent(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[tdFileDrop]',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'multiple': [{ type: Input, args: ['multiple', ] },],
'disabled': [{ type: Input, args: ['disabled', ] },],
'onFileDrop': [{ type: Output, args: ['fileDrop', ] },],
'multipleBinding': [{ type: HostBinding, args: ['attr.multiple', ] },],
'disabledBinding': [{ type: HostBinding, args: ['attr.disabled', ] },],
'onDrop': [{ type: HostListener, args: ['drop', ['$event'], ] },],
'onDragOver': [{ type: HostListener, args: ['dragover', ['$event'], ] },],
'onDragEnter': [{ type: HostListener, args: ['dragenter', ['$event'], ] },],
'onDragLeave': [{ type: HostListener, args: ['dragleave', ['$event'], ] },],
};
}

function TdFileDropDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdFileDropDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdFileDropDirective.ctorParameters;
/** @type {?} */
TdFileDropDirective.propDecorators;
/** @type {?} */
TdFileDropDirective.prototype._multiple;
/** @type {?} */
TdFileDropDirective.prototype._disabled;
/**
 * fileDrop?: function
 * Event emitted when a file or files are dropped in host element after being validated.
 * Emits a [FileList | File] object.
 * @type {?}
 */
TdFileDropDirective.prototype.onFileDrop;
/** @type {?} */
TdFileDropDirective.prototype._renderer;
/** @type {?} */
TdFileDropDirective.prototype._element;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
